import { render, staticRenderFns } from "./DeletePrinterModal.vue?vue&type=template&id=265c8dea"
import script from "./DeletePrinterModal.vue?vue&type=script&lang=js"
export * from "./DeletePrinterModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports